module.exports = __webpack_public_path__ + "static/media/post-1.a8de308e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post-1.jpg
// module id = 1181
// module chunks = 33